import React from 'react';
import { connect } from 'react-redux';
import { RootState, actions } from '../store';
import { withRouter, RouteComponentProps } from 'react-router';
import FontAwesome from 'react-fontawesome';
import { images, checkbox, heartOutline, heart, clipboard, squareOutline } from 'ionicons/icons';
import {
  IonSkeletonText, IonCol, IonButton, IonThumbnail, IonLabel,
  IonItemSliding, IonIcon, IonItem, IonItemOptions, IonItemOption,
} from '@ionic/react';
import { Place } from '../store/places/types';
import { Token } from '../store/users/types';

type Props = RouteComponentProps<{}> & typeof mapDispatchToProps & ReturnType<typeof mapStateToProps> & {
  place?: any;
  // listType: "all" | "favorites";
  listType: string;
}

type State = {
  imageLoaded: boolean;
}

class PlaceListItem extends React.Component<Props, State> {
  ionItemSlidingRef: React.RefObject<any>;
  defaultState: State = {
    imageLoaded: false,
  };

  constructor(props: Props) {
    super(props);
    this.state = {
      ...this.defaultState,
    };
    this.ionItemSlidingRef = React.createRef();
  }

  componentDidMount() {
    // let { place } = this.props;
    // if (!place.id) {
    //   place = this.props.parkMap[place.park_code! || place.parkCode!];
    // }
    // let pic = place && place.image;
    // if (pic) {
    //   pic = '/assets/img/thumbs/' + pic;
    // }
    // this.setState({
    //   ...this.state,
    //   place,
    //   pic,
    //   imageLoaded: true,
    // });
  }

  showImage = () => {
    this.setState(() => ({
      ...this.state,
      imageLoaded: true,
    }));
  }

  closeSlide = () => {
    // this.ionItemSlidingRef.current.close()
  }

  toggleVisitedPlace = () => {
    const { parkCode: id } = this.props.place;
    const { myList, place } = this.props;
    this.closeSlide();
    if (myList && myList[id] && place.tags.includes('visited')) {
      this.props.removeFromVisitedPlaces(myList, this.props.place);
      return;
    }
    this.props.addToVisitedPlaces(myList, this.props.place);
  }

  toggleBucketList = () => {
    const { parkCode: id } = this.props.place;
    const { myList, place } = this.props;
    this.closeSlide();
    if (myList && myList[id] && place.tags.includes('bucket')) {
      this.props.removeFromBucketList(this.props.myList, this.props.place);
      return;
    }
    this.props.addToBucketList(this.props.myList, this.props.place);
  }

  toggleFavorite = () => {
    const { parkCode: id } = this.props.place;
    const { myList, place, isLoggedIn, addToList, tokens } = this.props;
    this.closeSlide();
    if (!isLoggedIn) {
      if (myList && myList[id] && place.tags.includes('favorites')) {
        this.props.removeFromFavorites(myList, place);
        return;
      }
      this.props.addToFavorites(myList, place);
    }
    
    if (isLoggedIn) {
      addToList(tokens, { type: 'favorites', place });
    }
  }

  navigateToPlace = (parkCode: string) => () => {
    this.closeSlide();
    this.props.history.push(`${this.props.history.location.pathname}/places/${parkCode}`);
  }

  render() {
    const { isLoggedIn } = this.props;
    let { place } = this.props;
    place = this.props.parkMap[place.park_code! || place.parkCode!];
    let pic = place && place.image;
    if (pic) {
      pic = '/assets/img/thumbs/' + pic;
    }
    if (!place) {
      return ( <></>);
    }
    const isVisited = place.tags && place.tags.indexOf('visited') >= 0;
    const isFavorite = place.tags && place.tags.indexOf('favorites') >= 0;
    const isBucketList = place.tags && place.tags.indexOf('bucket') >= 0;
    return (
      // <IonItemSliding ref={this.ionItemSlidingRef}>
      <>
        <IonItem button onClick={this.navigateToPlace(place.parkCode)}>
          { pic ?
            <IonThumbnail  slot="start">
              <IonSkeletonText class={this.state.imageLoaded ? 'hidden' : 'loadingslow'}></IonSkeletonText>
              <img className={this.state.imageLoaded ? '' : 'hidden'}
                alt={place.parkCode}
                src={pic}
                onLoad={this.showImage}
              />
            </IonThumbnail>
            :
            <IonThumbnail slot="start">
              <IonIcon color="primary" icon={images} size="large" />
            </IonThumbnail>
          }
  
          <IonLabel>
            <h3><div dangerouslySetInnerHTML={{__html: place.name}} /><FontAwesome name="rocket" /></h3>
            {/* <IonSkeletonText animated style={{ width: '80%' }} class={this.state.imageLoaded ? 'hidden' : 'loadingslow'}></IonSkeletonText>
            <IonSkeletonText animated style={{ width: '70%' }} class={this.state.imageLoaded ? 'hidden' : 'loadingslow'}></IonSkeletonText> */}
            <p className={this.state.imageLoaded ? '' : 'hidden'}>
            State: {place.states}
              <IonCol />
              { !isLoggedIn && isVisited ?
                <IonCol>
                  <IonIcon color="primary" icon={checkbox} />
                </IonCol>
                :
                ''
              }
              { !isLoggedIn && isFavorite ?
                <IonCol>
                  <IonIcon color="danger" icon={heart} />
                </IonCol>
                :
                ''
              }
              { !isLoggedIn && isBucketList ?
                <IonCol>
                  <IonIcon color="secondary" icon={clipboard} />
                </IonCol>
                :
                ''
              }
              <IonCol />
              <IonCol />
              <IonCol />
              <FontAwesome name="rocket" /> 
            </p>
          </IonLabel>
        </IonItem>
        
        {/* <IonItemOptions>
          <IonItemOption color="favorite" onClick={this.toggleVisitedPlace}>
            <IonButton color={isVisited ? "" : "default"} size="small">
              <IonIcon color={isVisited ? "" : "dark"} icon={isVisited ? checkbox : squareOutline} />
            </IonButton>
          </IonItemOption>
          <IonItemOption color="favorite" onClick={this.toggleFavorite}>
            <IonButton color={isFavorite ? "default" : "default"} size="small">
              <IonIcon color={isFavorite ? "danger" : "dark"} icon={isFavorite ? heart : heartOutline} />
            </IonButton>
          </IonItemOption>
          <IonItemOption color="favorite" onClick={this.toggleBucketList}>
            <IonButton color={isBucketList ? "secondary" : "default"} size="small">
              <IonIcon color={isBucketList ? "" : "dark"} icon={isBucketList ? clipboard : clipboard} />
            </IonButton>
          </IonItemOption>
        </IonItemOptions> */}
      {/* </IonItemSliding> */}
      </>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  // favorites: state.places.favorites,
  // bucketList: state.places.bucketList,
  tokens: state.users.tokens,
  isLoggedIn: state.users.loggedIn,
  parkMap: state.places.parkMap,
  myList: state.places.myList,
  visited: state.places.visitedPlaces,
});

const mapDispatchToProps = {
  addToList: (token: Token, place: any) => actions.places.addToList(token, place),
  addToFavorites: (places: Place[], place: Place) => actions.places.addToFavoritesList(places, place),
  removeFromFavorites: (places: Place[], place: Place) => actions.places.removeFromFavoritesList(places, place),
  addToVisitedPlaces: (places: Place[], place: Place) => actions.places.addToVisitedPlaces(places, place),
  removeFromVisitedPlaces: (places: Place[], place: Place) => actions.places.removeFromVisitedPlaces(places, place),
  addToBucketList: (places: Place[], place: Place) => actions.places.addToBucketList(places, place),
  removeFromBucketList: (places: Place[], place: Place) => actions.places.removeFromBucketList(places, place),
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(PlaceListItem));
